/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buyers_Will_Only_Get_Access_ToInputs */

const en_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyers will only get access to this content AFTER a successful payment. Perfect for tutorials, private galleries, or exclusive links.`)
};

const es_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los compradores solo tendrán acceso a este contenido DESPUÉS de un pago exitoso. Perfecto para tutoriales, galerías privadas o enlaces exclusivos.`)
};

const fr_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les acheteurs n'auront accès à ce contenu qu'APRÈS un paiement réussi. Parfait pour les tutoriels, les galeries privées ou les liens exclusifs.`)
};

const de_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käufer erhalten erst NACH erfolgreicher Zahlung Zugriff auf diesen Inhalt. Perfekt für Tutorials, private Galerien oder exklusive Links.`)
};

const ja_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入者は支払いが完了した後にのみ、このコンテンツにアクセスできます。チュートリアル、プライベートギャラリー、専用リンクに最適です。`)
};

const zh_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`买家仅在成功付款后才能访问这些内容。非常适合用于教程、私人图库或独家链接。`)
};

const ar_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيحصل المشترون على إمكانية الوصول إلى هذا المحتوى فقط بعد الدفع الناجح. مثالي للبرامج التعليمية، المعارض الخاصة، أو الروابط الحصرية.`)
};

const id_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembeli hanya akan mendapatkan akses ke konten ini SETELAH pembayaran berhasil. Sempurna untuk tutorial, galeri pribadi, atau tautan eksklusif.`)
};

const it_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli acquirenti avranno accesso a questo contenuto solo DOPO un pagamento riuscito. Perfetto per tutorial, gallerie private o link esclusivi.`)
};

const ru_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Покупатели получат доступ к этому контенту только ПОСЛЕ успешной оплаты. Идеально подходит для обучающих видео, частных галерей или эксклюзивных ссылок.`)
};

const pt_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os compradores só terão acesso a este conteúdo APÓS um pagamento bem-sucedido. Perfeito para tutoriais, galerias privadas ou links exclusivos.`)
};

const ko_buyers_will_only_get_access_to = /** @type {(inputs: Buyers_Will_Only_Get_Access_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구매자는 결제가 완료된 '후'에만 이 콘텐츠에 액세스할 수 있습니다. 튜토리얼, 비공개 갤러리 또는 독점 링크에 적합합니다.`)
};

/**
* | output |
* | --- |
* | "Buyers will only get access to this content AFTER a successful payment. Perfect for tutorials, private galleries, or exclusive links." |
*
* @param {Buyers_Will_Only_Get_Access_ToInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buyers_will_only_get_access_to = /** @type {((inputs?: Buyers_Will_Only_Get_Access_ToInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buyers_Will_Only_Get_Access_ToInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buyers_will_only_get_access_to(inputs)
	if (locale === "es") return es_buyers_will_only_get_access_to(inputs)
	if (locale === "fr") return fr_buyers_will_only_get_access_to(inputs)
	if (locale === "de") return de_buyers_will_only_get_access_to(inputs)
	if (locale === "ja") return ja_buyers_will_only_get_access_to(inputs)
	if (locale === "zh") return zh_buyers_will_only_get_access_to(inputs)
	if (locale === "ar") return ar_buyers_will_only_get_access_to(inputs)
	if (locale === "id") return id_buyers_will_only_get_access_to(inputs)
	if (locale === "it") return it_buyers_will_only_get_access_to(inputs)
	if (locale === "ru") return ru_buyers_will_only_get_access_to(inputs)
	if (locale === "pt") return pt_buyers_will_only_get_access_to(inputs)
	return ko_buyers_will_only_get_access_to(inputs)
});